// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WZXbL","content":"styles_content__dAj2_"};